import {
  APP_INITIALIZER,
  ApplicationConfig,
  provideZoneChangeDetection
} from '@angular/core';

import {
  provideHttpClient,
  withFetch,
  withInterceptors
} from '@angular/common/http';

import { LuxonDateAdapter } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { provideAnimations } from '@angular/platform-browser/animations';

import {
  PreloadAllModules,
  provideRouter,
  withInMemoryScrolling,
  withPreloading
} from '@angular/router';

import { provideFuse } from '@fuse';
import { provideTransloco, TranslocoService } from '@ngneat/transloco';
import { firstValueFrom } from 'rxjs';

import { appRoutes } from 'app/app.routes';
import { provideAuth } from 'app/core/auth/auth.provider';
import { provideIcons } from 'app/core/icons/icons.provider';
import { mockApiServices } from 'app/mock-api';

import { TranslocoHttpLoader } from './core/transloco/transloco.http-loader';
import { backendAuthInterceptor } from './backend-auth.interceptor';

import { AppConfigService } from './services/app-config.service';
import { LookupCacheService } from 'app/services/lookup-cache/lookup-cache.service';

export function initAppFactory(
  configService: AppConfigService,
  lookupCacheService: LookupCacheService,
  translocoService: TranslocoService
) {
  return async () => {
    // 1) لازم الأول app config
    await configService.loadConfig();

    // 2) بعد ما config يخلص، حمّل البيانات الثابتة
    await lookupCacheService.init();

    // 3) تحميل اللغة الافتراضية
    // const defaultLang = translocoService.getDefaultLang();
    // translocoService.setActiveLang(defaultLang);

    // await firstValueFrom(translocoService.load(defaultLang));
    const lang_exist =
  localStorage.getItem('app-lang') ?? localStorage.setItem('app-lang',translocoService.getDefaultLang()) ;

const lang = localStorage.getItem('app-lang') ?? translocoService.getDefaultLang();
translocoService.setActiveLang(lang);


await firstValueFrom(
  translocoService.load(lang)
);


// document.documentElement.dir =
//   lang === 'eg'
//   ? 'rtl'
//   : 'ltr';
    console.log(lang);

  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),

    provideHttpClient(
      withFetch(),
      withInterceptors([backendAuthInterceptor])
    ),

    provideRouter(
      appRoutes,
      withPreloading(PreloadAllModules),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled'
      })
    ),

    provideAnimations(),

    {
      provide: DateAdapter,
      useClass: LuxonDateAdapter
    },

    {
      provide: MAT_DATE_FORMATS,
      useValue: {
        parse: {
          dateInput: 'D'
        },
        display: {
          dateInput: 'DDD',
          monthYearLabel: 'LLL yyyy',
          dateA11yLabel: 'DD',
          monthYearA11yLabel: 'LLLL yyyy'
        }
      }
    },

    provideTransloco({
      config: {
        availableLangs: [
          {
            id: 'en',
            label: 'English'
          },
          {
            id: 'eg',
            label: 'العربيه'
          }
        ],
        defaultLang: 'eg',
        fallbackLang: 'eg',
        reRenderOnLangChange: true,
        prodMode: true
      },
      loader: TranslocoHttpLoader
    }),

    {
      provide: APP_INITIALIZER,
      useFactory: initAppFactory,
      deps: [
        AppConfigService,
        LookupCacheService,
        TranslocoService
      ],
      multi: true
    },

    provideAuth(),
    provideIcons(),

    provideFuse({
      mockApi: {
        delay: 0,
        services: mockApiServices
      },
      fuse: {
        layout: 'classy',
        scheme: 'light',
        screens: {
          sm: '600px',
          md: '960px',
          lg: '1280px',
          xl: '1440px'
        },
        theme: 'theme-default',
        themes: [
          {
            id: 'theme-default',
            name: 'Default'
          },
          {
            id: 'theme-brand',
            name: 'Brand'
          },
          {
            id: 'theme-teal',
            name: 'Teal'
          },
          {
            id: 'theme-rose',
            name: 'Rose'
          },
          {
            id: 'theme-purple',
            name: 'Purple'
          },
          {
            id: 'theme-amber',
            name: 'Amber'
          }
        ]
      }
    })
  ]
};